import styled from "styled-components";
export default styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  & > img {
    max-width: 100%;
    border-radius: 0.875rem;
  }
`;
